import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { UserAssetListApi } from '@/server/AssetList/user';
import { queryKeys } from './query-keys';
import { AssetItem } from '@/type';
import { deepClone, isNil } from '@/utils';
import { message } from '@easyv/react-components';

export const useGetUserAssetList = (options?: {
  pageNum?: number;
  pageSize?: number;
  name?: string;
  id?: string;
}) => {
  const query = useQuery({
    queryKey: queryKeys.userAssets(),
    queryFn: () => UserAssetListApi.getUserAssets(options),
  });

  return query;
};

export const useUpdateUserAsset = () => {
  const queryClient = useQueryClient();

  const { mutate } = useMutation({
    mutationKey: ['useUpdateUserAsset'],
    mutationFn: (query: { assetId: string; name?: string; parentId?: string }) =>
      UserAssetListApi.updateAsset(query),
    onSuccess: (_, req) => {
      // queryClient.invalidateQueries({ queryKey: queryKeys.userAssets() });
      queryClient.setQueryData<AssetItem[]>(queryKeys.userAssets(), (old) => {
        if (isNil(old)) return;

        const replaceNewData = (a: AssetItem) => {
          const newA = deepClone(a);
          req.name && (newA.name = req.name);
          req.parentId && (newA.parentId = req.parentId);
          return newA;
        };

        const newarr = old.map((a) => {
          if (a.id === req.assetId) {
            const newA = replaceNewData(a);
            return newA;
          }
          return a;
        });

        return newarr;
      });
    },
    onError: (err: Error) => {
      console.error(err.message);
      message.error(`更新资源失败：${err.message}`);
    },
  });
  return mutate;
};
